import React from "react";
import classnames from "classnames";

const Switch = ({ children, readOnly, ...props }) => {
  const prefixCls = "switch";
  const inputCls = `${prefixCls}__input`;
  const checkCls = `${prefixCls}__switch`;
  const labelCls = `${prefixCls}__label`;

  const componentCls = classnames(prefixCls);

  const switchComponentCls = classnames(
    {
      [`${checkCls}--checked`]: readOnly &&
        (props.checked || props.defaultChecked),
      [`${checkCls}--readonly`]: readOnly,
    },
    checkCls
  );

  return (
    <label className={componentCls}>
      {readOnly
        ? null
        : <input className={inputCls} type="checkbox" {...props} />}
      <div className={switchComponentCls} />
      <div className={labelCls}>
        {children}
      </div>
    </label>
  );
};

export default Switch;



// WEBPACK FOOTER //
// ./casper/sass/components/switch/switch.js